export default __webpack_public_path__ + "static/media/logo.47bf0d62.png";